if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.hideErrors = this.dataset.hideErrors === 'true';
        if (!this.form) return;
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (this.submitButton && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const formData = new FormData(this.form);
        this.applyContactLensEyeQuantity(formData);
        this.applyExternalFrameCodeProperty(formData);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        if (this.isCustomPolarisedAddOnMode()) {
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(this.buildCustomPolarisedAddOnPayload(formData));
          if (this.cart) this.cart.setActiveElement(document.activeElement);
        } else {
          delete config.headers['Content-Type'];
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton && this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              const submitButtonLabel = this.submitButton.querySelector('span');
              if (submitButtonLabel) submitButtonLabel.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const renderCartResponse = (cartResponse) => {
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: cartResponse,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');

              if (window.CityCartEdit && typeof window.CityCartEdit.refreshCartDrawer === 'function') {
                if (quickAddModal) quickAddModal.hide(true);
                return window.CityCartEdit.refreshCartDrawer(true, 1);
              }

              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(cartResponse);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(cartResponse);
              }
            };

            if (window.CityCartEdit && typeof window.CityCartEdit.getKey === 'function' && window.CityCartEdit.getKey()) {
              return window.CityCartEdit.removeEditedCartLine({ cart: this.cart, response, render: false })
                .then((cartResponse) => {
                  renderCartResponse(cartResponse || response);
                })
                .catch((error) => {
                  console.warn('Cart edit replacement failed.', error);
                  renderCartResponse(response);
                });
            }

            renderCartResponse(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      isCustomPolarisedAddOnMode() {
        return (
          this.form.dataset.cityCustomPolarisedActive === 'true' &&
          this.form.dataset.cityCustomPolarisedStandardVariantId &&
          this.form.dataset.cityCustomPolarisedAddonVariantId
        );
      }

      applyExternalFrameCodeProperty(formData) {
        if (!this.form.id) return;
        const frameCodeInput = this.form.querySelector('[data-city-sun-frame-code-property]');
        const frameCode = frameCodeInput && !frameCodeInput.disabled ? frameCodeInput.value.trim() : '';

        if (frameCode) {
          formData.set('properties[Frame code]', frameCode);
        } else {
          formData.delete('properties[Frame code]');
        }
      }

      applyContactLensEyeQuantity(formData) {
        const leftValue = formData.get('properties[Quantity Left]');
        const rightValue = formData.get('properties[Quantity Right]');
        if (leftValue === null && rightValue === null) return;

        const left = Math.max(0, parseInt(leftValue || '0', 10) || 0);
        const right = Math.max(0, parseInt(rightValue || '0', 10) || 0);
        const totalBoxes = left + right;

        if (totalBoxes > 0) formData.set('quantity', String(totalBoxes));
      }

      buildCustomPolarisedAddOnPayload(formData) {
        const quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);
        const groupId = `custom-pol-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const tint = formData.get('properties[Custom polarised lens colour]') || '';
        const parentProperties = {};

        parentProperties['Lens Option'] = 'Custom Polarised Upgrade';
        if (tint) parentProperties['Custom polarised lens colour'] = tint;

        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (!match || value === '') return;
          if (match[1] === 'Lens Option' || match[1] === 'Custom polarised lens colour') return;
          parentProperties[match[1]] = value;
        });

        parentProperties['_city_custom_polarised_parent'] = 'true';
        parentProperties['_city_custom_polarised_group'] = groupId;
        parentProperties['_city_custom_polarised_add_on_variant_id'] = this.form.dataset.cityCustomPolarisedAddonVariantId;

        const addonProperties = {
          '_city_custom_polarised_add_on': 'true',
          '_city_custom_polarised_group': groupId,
          '_city_custom_polarised_parent_variant_id': this.form.dataset.cityCustomPolarisedStandardVariantId,
        };

        const payload = {
          items: [
            {
              id: Number(this.form.dataset.cityCustomPolarisedStandardVariantId),
              quantity,
              properties: parentProperties,
            },
            {
              id: Number(this.form.dataset.cityCustomPolarisedAddonVariantId),
              quantity,
              properties: addonProperties,
            },
          ],
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        return payload;
      }
    }
  );
}
